"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationInput = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _reactPlacesAutocomplete = require("react-places-autocomplete");

var _Optimizers = require("../../utils/Optimizers");

var _ProfileProvider = require("../../provider/ProfileProvider");

var _PlacesPlainInput2 = _interopRequireDefault(require("../PlacesPlainInput"));

var _RadiusSlider = require("../RadiusSlider");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * singleChoice component for whitelabel registration funnel
 * @param {*} param0
 */
var LocationComponent = function LocationComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var _useState = (0, _react.useState)(context[config.valueName].value.name),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      adress = _useState2[0],
      handlePlacesChange = _useState2[1];

  var touched = (0, _ProfileProvider.isTouched)(context[config.valueName]);

  var handleOnFocus = function handleOnFocus() {
    setTimeout(function () {
      var bodyWidth = document.body.clientWidth;

      if (bodyWidth < 991) {
        //Mobile View
        var introText = document.getElementById('introText');
        introText.style.display = 'none';

        var _PlacesPlainInput = document.getElementById('placesInput');

        _PlacesPlainInput.focus();
      }
    }, 150);
  };

  var hideKeyboard = function hideKeyboard() {
    setTimeout(function () {
      document.activeElement.blur();
    }, 100);
  };

  var handlePlacesSelect = function handlePlacesSelect(address) {
    (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
      return handleAddress(results);
    }).catch(function (error) {
      return console.error('Error', error);
    });
    hideKeyboard();
  };

  var handleAddress = function handleAddress(results) {
    var address = results[0].formatted_address;
    (0, _reactPlacesAutocomplete.getLatLng)(results[0]).then(function (latLng) {
      // write to profileProvider
      setValue(config.valueName, {
        latitude: latLng.lat.toString(),
        longitude: latLng.lng.toString(),
        name: address
      });
      handlePlacesChange(address);
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    className: _styleModule.default.location,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      id: "introText",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
        headline: t(config.translations.text),
        text: config.translations.hint ? t(config.translations.hint) : ''
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlacesPlainInput2.default, {
      location: adress,
      handlePlacesChange: handlePlacesChange,
      handlePlacesSelect: handlePlacesSelect,
      handleOnFocus: handleOnFocus,
      inputText: t(config.translations.inputText)
    }), touched && config.withRadius && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadiusSlider.RadiusSlider, {
      config: config,
      setValue: setValue,
      context: context
    })]
  });
};

var LocationInputWrapper = (0, _Optimizers.memoizeComponentByValue)(LocationComponent);

var LocationInput = function LocationInput(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(LocationInputWrapper, {
    config: config,
    context: context
  });
};

exports.LocationInput = LocationInput;